/* global window */
import 'es6-object-assign/auto';
import * as bi from './bi';
import {sanitizeRootNodes, throttle, warnAndThen} from './utils';
import {sanitize, useMobileVersion} from './config';
import render, {updateProfileImage} from './render';
import * as fetch from './initFetch';

function removeClasses(classes) {
  document.body.classList.remove(...classes);
}

function hackForWixHeaderAndFooter() {
  const wixHeaderAndFooterClassesToRemove = ['device-mobile-optimized', 'wix-menu-enabled', 'wix-menu-mobile-enabled', 'wix-menu', 'wix-menu-top-banner'];
  removeClasses(wixHeaderAndFooterClassesToRemove);

  (function () {
    window.addEventListener('resize', resizeThrottler, false);
    let resizeTimeout;
    function resizeThrottler() {
      // ignore resize events as long as an actualResizeHandler execution is in the queue
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(() => {
          resizeTimeout = null;
          actualResizeHandler();
          // The actualResizeHandler will execute at a rate of 15fps
        }, 66);
      }
    }

    function actualResizeHandler() {
      // handle the resize event
      removeClasses(wixHeaderAndFooterClassesToRemove);
    }
  })();
}

let inited = false;
let storedConfig;

export default function (config, nodes = {}, skipInitCheck = false) {
  if (!skipInitCheck && inited) {
    return warnAndThen('Header and footer is already embedded, don\'t do it twice');
  } inited = true;

  hackForWixHeaderAndFooter();

  config = sanitize(config);
  storedConfig = Object.assign({}, config);

  const tasks = document.cookie.indexOf('wixClient') >= 0 ?
    [fetch.experiments(), fetch.i18n(config), fetch.userDetails(config), fetch.profileImage(config)] :
    [fetch.experiments(), fetch.i18n(config)];

  return Promise.all(tasks).then(([experiments, translations, user, profileImage]) => {
    if (experiments['specs.ChineseAndThaiLanguagesInMenu'] === 'true') {
      config.supportedLanguages.push('zh', 'th');
    }

    if (experiments['specs.marketing.EnableAnonMainFunnelIntroLinks'] === 'true' || experiments['specs.marketing.HeaderAndFooterLoginButtonRename'] === 'true') {
      if (config.language === 'en') {
        translations.signin = translations.signinAnonMainFunnel;
      }
    }

    let isMobile = useMobileVersion(config);

    if (!translations) {
      return warnAndThen();
    }

    if (user) {
      user.profileImage = profileImage;
    }

    sanitizeRootNodes(nodes);

    window.addEventListener('resize', throttle(() => {
      if (isMobile !== useMobileVersion(config)) {
        isMobile = useMobileVersion(config);
        render(nodes, config, translations, user);
      }
    }, 200));
    render(nodes, config, translations, user);


    bi.headerAndFooterBiLogger.log({
      evid: bi.hfBiConfig.init,
      is_mobile: isMobile, // eslint-disable-line
      component: 'header'
    });
  })
    .catch(e =>
      warnAndThen('Error embedding header and footer', e)
    );
}

// support legacy wix-header-and-footer's reload() controller
export function reload() {
  if (!storedConfig || document.cookie.indexOf('wixClient') < 0) {
    return;
  }
  fetch.profileImage(storedConfig)
    .then(src => updateProfileImage(src, storedConfig));
}
